document.addEventListener("DOMContentLoaded", () => {

    const accordionItems = document.querySelectorAll(".frw-item");

    if (!accordionItems.length) return;

    accordionItems.forEach((item) => {

        const button = item.querySelector(".frw-trigger");
        const content = item.querySelector(".frw-answer");
        const icon = item.querySelector(".frw-icon");

        if (item.classList.contains("active")) {
            content.style.display = "block";
            content.style.overflow = "hidden";
            content.style.maxHeight = content.scrollHeight + "px";
            content.style.transition = "max-height .35s ease";
            icon.innerHTML = "&minus;";
            button.setAttribute("aria-expanded", "true");
        } else {
            content.style.display = "block";
            content.style.overflow = "hidden";
            content.style.maxHeight = "0";
            content.style.transition = "max-height .35s ease";
            icon.innerHTML = "+";
            button.setAttribute("aria-expanded", "false");
        }

        button.addEventListener("click", () => {

            const isOpen = item.classList.contains("active");

            accordionItems.forEach((accordion) => {

                accordion.classList.remove("active");

                const accordionContent = accordion.querySelector(".frw-answer");
                const accordionButton = accordion.querySelector(".frw-trigger");
                const accordionIcon = accordion.querySelector(".frw-icon");

                accordionContent.style.maxHeight = "0";
                accordionButton.setAttribute("aria-expanded", "false");
                accordionIcon.innerHTML = "+";

            });

            if (!isOpen) {

                item.classList.add("active");

                content.style.maxHeight = content.scrollHeight + "px";
                button.setAttribute("aria-expanded", "true");
                icon.innerHTML = "&minus;";

            }

        });

    });

});